import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable/index";
import useApi from "../../core/customhook/useApi";
import Loader from "../../core/common/loader/index";
import { Modal, Button } from "react-bootstrap";
import { apibaseurl } from "../../environment";

const Manager: React.FC = () => {
    const [loading, setLoading] = useState(true);
    const [managerView, setManagerView] = useState<any>([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState<any>(null);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectReason, setRejectReason] = useState("");
    const [pendingRejectId, setPendingRejectId] = useState<string | null>(null);
    const [selectedTrainer, setSelectedTrainer] = useState<any>([]);


    // Fetch nominations data
    const { data: managerViewData, error } = useApi("/api/get-all-nomination", {
        method: "GET",
        autoCall: true,
    });
    console.log("mmmmmmmmmmmmmmmmmmmmmmmmmmmm", managerViewData)

    useEffect(() => {
        if (managerViewData?.data) {
            setManagerView(managerViewData.data);
            setLoading(false);
        }
        if (error) {
            setLoading(false);
            Swal.fire("Error", "Failed to load nominations", "error");
        }
    }, [managerViewData, error]);

    // API hook for updating status
    const { data: updateStatus, callApi: updateNominationStatus } = useApi("/api/update-nomination-status", {
        method: "POST",
        autoCall: false,
    });

    const openConfirmationModal = (id: any) => {
        setSelectedId(id);
        setShowModal(true);
    };

    const openRejectModal = (id: string) => {
        setPendingRejectId(id);
        setRejectReason("");
        setShowRejectModal(true);
    };

    console.log(selectedId, "selected id is here state");


    const handleConfirmApprove = async () => {
        console.log("selexted id any me ", selectedId)
        if (!selectedId) return;
        const payload = {
            id: selectedId,
            status: "APPROVED",
        }
        // console.log("payload data", payload)
        try {
            const response = await updateNominationStatus(payload);


            if (response?.success) {
                Swal.fire("Approved", response.message || "Nomination approved successfully.", "success");

                // Update the local list
                setManagerView((prev: any) =>
                    prev.map((item: any) =>
                        item.id === selectedId ? { ...item, status: "APPROVED" } : item
                    )
                );
            } else {
                console.log("yaha ka error hai 1")
                Swal.fire("Error", response?.message || "Failed to approve nomination", "error");
            }
        } catch (error: any) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Failed to approve nomination due to unexpected error.";
            console.log("yaha ka error hai 2")
            Swal.fire("Error", errorMessage, "error");
        } finally {
            setShowModal(false);
            setSelectedId(null);
        }
    };

    const handleUpdateStatus = async (id: string, status: string, reason?: string) => {
        try {
            const payload: any = { id, status };
            if (status === "REJECTED" && reason) {
                payload.rejection_reason = reason;
            }

            const response = await updateNominationStatus(payload);

            if (response?.success) {
                Swal.fire(
                    status === "REJECTED" ? "Rejected" : "Updated",
                    response?.message || `Nomination has been ${status.toLowerCase()}`,
                    "success"
                );

                setManagerView((prev: any) =>
                    prev.map((item: any) =>
                        item.id === id ? { ...item, status } : item
                    )
                );
            } else {
                Swal.fire("Error", response?.message || `Failed to update status to ${status}`, "error");
            }
        } catch (error: any) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                `Failed to update status to ${status}`;
            Swal.fire("Error", errorMessage, "error");
        } finally {
            setShowRejectModal(false);
            setPendingRejectId(null);
        }
    };


    const columns = [
        {
            title: "Employee ID",
            dataIndex: "employee_id",
            sorter: (a: any, b: any) => a.employee_id.localeCompare(b.employee_id),
        },
        {
            title: "Employee Name",
            dataIndex: "employee_name",
            sorter: (a: any, b: any) => a.employee_name.localeCompare(b.employee_name),
        },
        {
            title: "Training Title",
            dataIndex: "training_title",
            sorter: (a: any, b: any) => a.training_title.localeCompare(b.training_title),
        },
        {
            title: "Trainers",
            dataIndex: "trainers",
            key: "trainers",
            render: (trainers: any[], record: any) => (
                <div className="d-flex align-items-center gap-2">

                    <button
                        type="button"
                        className="btn btn-sm text-primary"
                        style={{ border: "none", background: "transparent", cursor: "pointer" }}
                        title="View Trainers"
                        data-bs-toggle="modal"
                        data-bs-target="#trainer_information"
                        onClick={() => setSelectedTrainer(trainers)}
                    >
                        <i className="bi bi-eye"></i>
                    </button>

                </div>
            )
        },

        {
            title: "Venue",
            dataIndex: "venue",
            sorter: (a: any, b: any) => a.venue.localeCompare(b.venue),
        },
        {
            title: "Start Date",
            dataIndex: "start_date",
            render: (date: string) =>
                new Date(date).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                }),
            sorter: (a: any, b: any) =>
                new Date(a.start_date).getTime() - new Date(b.start_date).getTime(),
        },
        {
            title: "End Date",
            dataIndex: "end_date",
            render: (date: string) =>
                new Date(date).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                }),
            sorter: (a: any, b: any) =>
                new Date(a.end_date).getTime() - new Date(b.end_date).getTime(),
        },

        {
            title: "Training Time",
            key: "training_time",
            render: (_: any, record: any) => {
                const formatTime = (time: string) => {
                    const [hours, minutes] = time.split(":");
                    const h = parseInt(hours, 10);
                    const ampm = h >= 12 ? "PM" : "AM";
                    const formattedHour = h % 12 === 0 ? 12 : h % 12;
                    return `${formattedHour}:${minutes} ${ampm}`;
                };

                const startTime = formatTime(record.start_time);
                const endTime = formatTime(record.end_time);

                return `${startTime} - ${endTime}`;
            },
        },

        {
            title: "Status",
            dataIndex: "status",
            render: (status: string) => {
                let className = "";

                if (status === "APPROVED") {
                    className = "text-success"; // green
                } else if (status === "REJECTED") {
                    className = "text-danger"; // red
                } else if (status === "PENDING") {
                    className = "text-warning"; // orange/yellow
                }

                return <span className={className}>{status}</span>;
            },
            sorter: (a: any, b: any) => a.status.localeCompare(b.status),
        },

        {
            title: "Action",
            dataIndex: "id",
            render: (_: any, record: any) => (
                <div className="d-flex gap-2">
                    <button
                        className="btn btn-sm text-success"
                        title="Approve"
                        style={{ border: "none", background: "transparent" }}
                        onClick={() => openConfirmationModal(record.id)}
                    >
                        <i className="bi bi-check-circle"></i>
                    </button>

                    <button
                        className="btn btn-sm text-danger"
                        title="Reject"
                        style={{ border: "none", background: "transparent" }}
                        onClick={() => openRejectModal(record.id)}
                    >
                        <i className="bi bi-x-circle"></i>
                    </button>

                </div>
            ),
        },
    ];

    return (
        <div className="page-wrapper">
            <div className="content">
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
                        <Loader />
                    </div>
                ) : (
                    <>
                        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                            <div className="my-auto mb-2">
                                <h2 className="mb-1">Manager</h2>
                                <nav>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to={all_routes.employeeDashboard}>
                                                <i className="ti ti-smart-home" />
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item">Training Management</li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Manager View
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
                                <h5 className="mb-0">Manager</h5>
                            </div>

                            <div className="card-body">
                                <div className="card table-responsive">
                                    <Table dataSource={managerView} columns={columns} Selection={false} showSearchInput={true} />
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>

            <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
                <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
            </div>


            <div className="modal fade" id="trainer_information">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Trainer Information</h4>
                            <button
                                type="button"
                                className="btn-close custom-btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="ti ti-x" />
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Trainer Name</th>
                                            <th>Gender</th>
                                            <th>Expertise Area</th>
                                            <th>Experience</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedTrainer?.length > 0 ? (
                                            selectedTrainer.map((record: any, index: any) => (
                                                <tr key={index}>
                                                    <td>
                                                        <div
                                                            className="d-flex align-items-center"
                                                            style={{ minWidth: "180px" }}
                                                        >
                                                            <img
                                                                src={
                                                                    record.profile_picture
                                                                        ? `${apibaseurl}/${record.profile_picture}`
                                                                        : "./assets/img/logo/profilepic.jpg"
                                                                }
                                                                alt={record.full_name}
                                                                className="rounded-circle me-2"
                                                                style={{
                                                                    width: "40px",
                                                                    height: "40px",
                                                                    objectFit: "cover",
                                                                }}
                                                            />
                                                            <span className="fs-14 fw-medium">
                                                                {record.full_name}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td style={{ minWidth: "140px" }}>
                                                        {record.gender}
                                                    </td>
                                                    <td style={{ minWidth: "140px" }}>
                                                        {record.expertise_area}
                                                    </td>
                                                    <td style={{ minWidth: "100px" }}>
                                                        {record.experience} years
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={3} className="text-center text-muted py-3">
                                                    No trainer data available.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Approve Confirmation Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Approval</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to <strong>approve</strong> this nomination?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="me-2" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="success" className="" onClick={handleConfirmApprove}>
                        Confirm Approve
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* reject confirmation modal  */}
            <Modal show={showRejectModal} onHide={() => setShowRejectModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Reject Nomination</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label htmlFor="reason">Please enter reason for rejection:</label>
                        <textarea
                            id="reason"
                            className="form-control"
                            value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)}
                            rows={4}
                            placeholder="Enter reason here..."
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="me-2" onClick={() => setShowRejectModal(false)}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() => {
                            if (!rejectReason.trim()) {
                                Swal.fire("Warning", "Please enter a reason for rejection.", "warning");
                                return;
                            }
                            if (pendingRejectId) {
                                handleUpdateStatus(pendingRejectId, "REJECTED", rejectReason);
                            }
                        }}
                    >
                        Confirm Reject
                    </Button>
                </Modal.Footer>
            </Modal>




        </div>
    );
};

export default Manager;
